export function parsePaginatedList(response, itemsKey) {
  const data = response.data

  if (data && Array.isArray(data[itemsKey])) {
    return {
      items: data[itemsKey],
      pagination: data.pagination || null,
    }
  }

  return {
    items: Array.isArray(data) ? data : [],
    pagination: null,
  }
}

export function hasMorePages(pagination) {
  return pagination != null && pagination.page < pagination.total_pages
}

export function buildListParams({ page, perPage, season, wheelSize, extra = {} } = {}) {
  const params = { ...extra }

  if (page != null) {
    params.page = page
  }
  if (perPage != null) {
    params.per_page = perPage
  }
  if (season) {
    params.season = season
  }
  if (wheelSize) {
    params.wheel_size = wheelSize
  }

  return params
}
